<style>
    .tabs {
      display: flex;
      cursor: pointer;
    }
    .tab {
      margin-right: 20px;
      padding: 10px 20px;
      background-color: #f0f0f0;
      border-radius: 5px;
    }
    .tab-active {
      background-color: #007bff;
      color: white;
    }
    .content {
      padding: 20px;
      border: 1px solid #ccc;
      margin-top: 20px;
      border-radius: 5px;
    }
  </style>

<script>
import { mapActions, mapGetters } from 'vuex';
import ListItem from './components/ListItem';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'odemeTalep',
  components: {
    ListItem,
  },
  mixins: [snackbarMixin],
  data() {
    return {
      activeTab: 0,
      hasError: false,
      isInitialized: false,
      isLoading: false,
      isSaving: false,
      itemList: [],
      formData: {
        item: {},
        visible: false,
        isCreateMode: false,
        olusturanKullanici: ''
      },
      sortBy: 'Id',
      descending: true,
      search: '',
    };
  },
  computed: {
    ...mapGetters('odemeTalep', ['listHeaders']),
  },
  mounted() {
    this.initializeData();
  },
  methods: {
    ...mapActions('odemeTalep',['getList', 'reject', 'approve']),
    ...mapActions('app', ['showOverlay', 'hideOverlay']),
    fetchData() {
      this.isLoading = true;
      this.showOverlay();
      this.getList()
        .then((data) => {
          this.itemList = data.data;
          this.isInitialized = true;
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
          this.hideOverlay();
        });
    },
    initializeData() {
      this.showOverlay();

      this.isLoading = true;
      Promise.all([this.getList()])
        .then(([odemeTalepResult]) => {
          this.itemList = odemeTalepResult.data;
          this.isInitialized = true;
          this.isLoading = false;
          this.hideOverlay();
        }, () => {
          this.hasError = true;
          this.isLoading = false;
        });
    },
    rejectRecord(id){
      this.isLoading = true;
      this.showOverlay();
      this.reject(id)
        .then(() => {
          this.showSuccessMessage(`${id} numaları bekleyen ödeme talebi reddedilmiştir.`);
          this.fetchData();
        })
        .catch((err) => {
          this.showErrorMessage(err.response && err.response.data);
        })
        .finally(() => {
          this.isDeleting = false;
          this.hideOverlay()
        });
    },
    approveRecord(id) {
      this.isDeleting = true;
      this.showOverlay();
      this.approve(id)
        .then(() => {
          this.showSuccessMessage(`${id} numaralı ödeme talebi onaylanmıştır.`);
          this.fetchData();
        })
        .catch((err) => {
          this.showErrorMessage(err.response && err.response.data);
        })
        .finally(() => {
          this.isDeleting = false;
          this.hideOverlay()
        });
    },
    openSaveDialog(data) {
      this.saveDialogData.item = data;
      this.saveDialogData.visible = true;
    },
    closeSaveDialog() {
      this.saveDialogData.visible = false;
    },
    customFilter(value, search, item) {
      // eslint-disable-next-line eqeqeq
      if (!search || search == '') {
        return true;
      }

      const searchStr = search.toString().toLowerCase().trim();

      return !!(
        // eslint-disable-next-line eqeqeq
        item.Id == searchStr
        || item.proje.toString().toLowerCase().trim().includes(searchStr)
        || item.tur.toString().toLowerCase().trim().includes(searchStr)
        || item.pfaaliyet.toString().toLowerCase().trim().includes(searchStr)
        || item.konu.toString().toLowerCase().trim().includes(searchStr)
        || item.tedarikci.toString().toLowerCase().trim().includes(searchStr)
        || item.tutar.toString().toLowerCase().trim().includes(searchStr)
      );
    },
  },
};
</script>

<template>
  <div>
    <template v-if="hasError">
      <p class="js-error-template ma-3">
        Bekleyen Ödeme Talepleri listesinde bir hata oluştu. Lütfen tekrar deneyin!
      </p>
    </template>

    <template v-else>
      <v-toolbar dark dense color="#9FA8A3">
        <b> Ödeme Talep Formu </b>
        <v-spacer />
        <v-btn @click="openSaveDialog(null)" style="align-self: right;">Yeni Form Oluştur</v-btn>
      </v-toolbar>

      <div class="tabs">
        <div :class="['tab', { 'tab-active': activeTab === 0 }]" @click="activeTab = 0">Genel Bilgiler</div>
        <div :class="['tab', { 'tab-active': activeTab === 1 }]" @click="activeTab = 1">Lojistik Ödeme Detayı</div>
      </div>

      <div class="content" v-if="activeTab === 0">
        <h3>Tab 1 Content</h3>
        
        <v-card>
          <v-card-text>
            <v-container grid-list-md class="pa-0">
              <v-layout row wrap>
                <v-flex xs12 md3 py-0>
                  <v-text-field
                    v-model="formData.olusturanKullanici"
                    label="Oluşturan"
                    height="22"
                    class="caption"
                    readonly
                  />
                </v-flex>
                
                
              </v-layout>
            </v-container>
          </v-card-text>

          <!-- <v-card-actions>
            <span v-if="hasError" style="color: red;">Lütfen sorulara cevap veriniz!</span>
            <v-spacer />
            <v-btn color="red lighten-3" dark @click="close">
              Kapat
            </v-btn>
            <v-btn color="red lighten-3" dark @click="deleteKys" v-if="isKysAdmin">
              Sil
            </v-btn>
            <v-btn color="success" @click="submit">
              Kaydet
            </v-btn>
          </v-card-actions> -->
        </v-card>

      </div>
      <div class="content" v-if="activeTab === 1">
        <h3>Tab 2 Content</h3>
        <p>Bu içerik Tab 2'ye ait.</p>
      </div>

     </template>
  </div>
</template>
